import { AppBar, Box, styled } from '@mui/material';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette?.themeColor?.main || '#255E5E',
  color: '#FFFFFF',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  padding: theme.spacing(0, 2),
}));

export const HeaderContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 0),
  maxWidth: '100%',
}));

export const LogoContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const AppNameContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '6px',
});

export const AppName = styled(Box)(({ theme }) => ({
  fontSize: '24px',
  fontWeight: 700,
  letterSpacing: '2.5px',
  lineHeight: 1.2,
  fontFamily: theme.typography.fontFamily,
  textTransform: 'none',
  position: 'relative',
  display: 'inline-block',
  background:
    'linear-gradient(135deg, #FFFFFF 0%, #F8F8F8 25%, #F0F0F0 50%, #E8E8E8 75%, #E0E0E0 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  filter: 'brightness(1.15) contrast(1.1)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-2px',
    left: '-2px',
    right: '-2px',
    bottom: '-2px',
    background:
      'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%)',
    borderRadius: '6px',
    zIndex: -1,
    opacity: 0.6,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-4px',
    left: 0,
    width: '100%',
    height: '3px',
    background:
      'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 20%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0.4) 80%, transparent 100%)',
    borderRadius: '2px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
    letterSpacing: '2px',
  },
}));

export const Tagline = styled(Box)(({ theme }) => ({
  fontSize: '11px',
  fontWeight: 400,
  letterSpacing: '0.3px',
  color: '#FFFFFF',
  opacity: 0.9,
  lineHeight: 1.2,
  marginTop: '2px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '10px',
  },
}));
